import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BookingFlowProvider } from './Context/BookingFlowProvider';
import { WebSettingsProvider } from './Context/WebSettings/WebSettingsContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './APICalling/queryClient';
import { initializeCookiebot } from './Utils/cookiebot';

// Expose queryClient to DevTools
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;

// Manual blocking: initialize once before providers load security/payment resources.
initializeCookiebot();
// Disable right-click context menu to prevent users from inspecting the page
document.addEventListener('contextmenu', (e) => e.preventDefault());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
          <WebSettingsProvider>
            <BookingFlowProvider>
              <App />
            </BookingFlowProvider>
          </WebSettingsProvider>
        </GoogleReCaptchaProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
